'use client';

import { useTranslations } from 'next-intl';
import { useEffect, useState } from 'react';

import { createGetFieldPropsWithTracking } from '@/fo/feature/auth/utils';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitInputBase } from '@/fo/ui/kit/input/base';
import { FormMessage, useForm } from '@/fo/ui/mod/form/base';
import { utilEventAuthModal } from '@/fo/util/event-auth-modal';

import { styles } from './FeatureAuthFormForgotPassword.styles';
import { formAction } from './formAction';

export function FeatureAuthFormForgotPassword() {
  const slots = styles();
  const t = useTranslations();
  const { action, getFieldProps, pending, state } = useForm(
    formAction,
    {},
    {
      displayMessageInToast: false
    }
  );
  const [emailValue, setEmailValue] = useState('');
  const [messageHidden, setMessageHidden] = useState(false);

  useEffect(() => {
    if (!pending && state?.message) setMessageHidden(false);
  }, [pending, state?.message]);

  useEffect(() => {
    if (state.data?.email != null) {
      setEmailValue(String(state.data.email));
    }
  }, [state.data?.email]);

  const getFieldPropsWithTracking = createGetFieldPropsWithTracking(
    getFieldProps,
    (name, value) => {
      if (name === 'email') setEmailValue(String(value));
    }
  );

  const isSubmitEnabled = Boolean(emailValue?.trim());

  return (
    <div className={slots.base()}>
      <div>
        <h3 className={slots.title()}>
          {t('form.forgotPassword.resetPassword')}
        </h3>

        <form action={action}>
          <UiKitInputBase
            label={t('form.label.email')}
            type="email"
            {...getFieldPropsWithTracking('email')}
            disabled={pending}
          />

          <UiKitButtonBase
            type="submit"
            className={slots.button()}
            loading={pending}
            color="secondary"
            disabled={!isSubmitEnabled}
          >
            {t('form.forgotPassword.changePassword')}
          </UiKitButtonBase>

          {!pending && state?.message && state?.status && !messageHidden && (
            <FormMessage
              message={state.message}
              status={state.status}
              duration={3000}
              onDismiss={() => {
                setMessageHidden(true);
                if (state?.status === 'success') {
                  utilEventAuthModal.showLogin(state.data?.email as string);
                }
              }}
            />
          )}
        </form>
      </div>
    </div>
  );
}
